import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
    selector: '[blackModalTrigger]',
    standalone: false
})
export class ModalTriggerDirective {  templateRef = inject<TemplateRef<any>>(TemplateRef);


}
